import configureStore from './setup';

const store = configureStore();

export default store;
